import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { keys, map } from 'ramda';
import ReactDOM from 'react-dom';

function getFormInputs() {
  const {queryParams} = this.props;

  if (!queryParams) {
    return null;
  }

  return map((name, index) => {
    return (
      <input
        key={index}
        name={name}
        type="hidden"
        value={queryParams[name]}
      />
    );
  }, keys(queryParams));
}

export default class FileDownload extends Component {

  static propTypes = {
    actionPath: PropTypes.string.isRequired,
    method: PropTypes.string,
    onDownloadComplete: PropTypes.func.isRequired,
    queryParams: PropTypes.object
  };

  static defaultProps = {
    method: 'GET'
  };

  componentDidMount() {
    ReactDOM.findDOMNode(this).submit();
    this.props.onDownloadComplete();
  }

  render() {
    const {actionPath, method} = this.props;

    return (
      <form
        action={actionPath}
        className="hidden"
        method={method}
      >
        {getFormInputs.call(this)}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FileDownload/FileDownload.js